<template>
  <v-app>
    <v-content>
      <v-container fluid>
        <v-row class="d-flex flex-column" align="center" justify="start">
          <Logo height="25vh" />
          <div v-if="success">
            <v-card flat width="30vw">
              <v-card-title class="headline my-10" style="word-wrap: normal;">
                {{ $t("We sent you a mail to reset your password") }}
              </v-card-title>
              <v-row justify="space-between" class="mx-4">
                <div>
                  {{ $t("Didn't receive it?") }}
                  <a @click="success = false"> {{ $t("Try again") }}</a>
                </div>
                <v-btn outlined color="primary" class="mx-2" @click="goToLogin">
                  {{ $t("Log in") }}
                </v-btn>
              </v-row>
            </v-card>
          </div>
          <div v-else>
            <v-card flat width="30vw" height="40vh">
              <v-card-title
                class="headline mt-4 mb-8"
                style="word-wrap: normal;"
              >
                {{ $t("Enter email to restore password") }}
              </v-card-title>
              <v-text-field
                :label="$t('email')"
                outlined
                flat
                dense
                name="email"
                v-model="email"
                :error-messages="$t(emailError)"
                prepend-inner-icon="mdi-account"
                type="text"
                @keydown.enter="restorePassword"
                class="mx-4"
              />
              <v-card-actions class="d-flex justify-end mx-2">
                <v-btn outlined color="primary" @click="goToLogin" class="mr-4">
                  {{ $t("Log in") }}
                </v-btn>
                <v-btn outlined color="primary" @click="restorePassword">
                  {{ $t("Restore password") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </div>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import AuthService from "@/service/auth_service";
import router from "@/router/index";
import Logo from "@/views/dashboard/components/Logo";

export default {
  components: { Logo },

  data() {
    return { email: "", emailError: "", success: false };
  },

  methods: {
    async restorePassword() {
      try {
        await AuthService.restorePassword(this.email);
        this.success = true;
      } catch (error) {
        switch (error.message) {
          case "invalid-email":
          case "user-not-found":
            this.emailError = "Invalid email";
            break;
        }
      }
    },

    goToLogin() {
      router.replace("/login");
    }
  }
};
</script>

<style></style>
